module.exports = __webpack_public_path__ + "img/filter.317d0d6e.svg";